function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function extractErrorDetail(error: unknown): string | undefined {
  if (!isRecord(error)) {
    return undefined;
  }

  let body: unknown;
  if ("response" in error && isRecord(error.response)) {
    body = "data" in error.response ? error.response.data : error.response.body;
  }

  if (isRecord(body)) {
    if ("displayableMessage" in body && typeof body.displayableMessage === "string") {
      return body.displayableMessage;
    }
    if (
      "errors" in body &&
      Array.isArray(body.errors) &&
      isRecord(body.errors[0]) &&
      typeof body.errors[0].detail === "string"
    ) {
      return body.errors[0].detail;
    }
    if ("message" in body && typeof body.message === "string") {
      return body.message;
    }
    if ("error" in body && typeof body.error === "string") {
      return body.error;
    }
  }

  if (
    "response" in error &&
    isRecord(error.response) &&
    "text" in error.response &&
    typeof error.response.text === "string"
  ) {
    return error.response.text;
  }

  if ("message" in error && typeof error.message === "string") {
    return error.message;
  }

  return undefined;
}
